import { Component, OnDestroy, OnInit } from '@angular/core';
import { NzTableData, NzTablePaginationPosition, NzTableSize } from 'ng-zorro-antd/table/src/table.types';
import { Observable, Subscription } from 'rxjs';
import { UserDto } from '@api/users/interfaces';
import { UserRestService } from '../../../services/rest/user-rest.service';
import { userPages } from '../user.routes';
import { Router } from '@angular/router';
import { ProtectedPrivacyService } from '../../../services/ui/protected-privacy.service';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';
import { MenuService } from '@app/services/menu';
import { PermissionService } from '@app/services/permission/permission.service';

class UserData {
	data: UserDto;
	url: string;
}

@Component({
	selector: 'app-user-dashboard',
	templateUrl: './user-dashboard.component.html',
	styleUrls: ['../user-pages.style.scss'],
})
export class UserDashboardComponent implements OnInit, OnDestroy {
	public simple = false;
	public loading = true;
	public pagination = true;
	public position: NzTablePaginationPosition = 'bottom';
	public header = true;
	public title = false;
	public expandable = true;
	public checkbox = false;
	public allChecked = false;
	public footer = false;
	public bordered = false;
	public sizeChanger = false;
	public size: NzTableSize = 'small';
	public privacyMode = false;
	public userAddSplitButton: SplitButtonElement = {
		title: 'user.add',
		icon: 'plus',
		type: 'default',
		callback: () => this.showUserCreate(),
	};

	public listOfData: UserData[] = [];
	public listOfDisplayData: UserData[] = [];

	private users$: Observable<UserDto[]>;

	private subscription = new Subscription();

	public userNameFilterValue = '';
	public userNameFilterVisible = false;
	public nameFilterValue = '';
	public nameFilterVisible = false;
	public emailFilterValue = '';
	public emailFilterVisible = false;
	public rolesFilterVisible = false;

	hasUserCreatePermission = false;

	public roles: [{
		label: string,
		value: string,
		checked: boolean,
	}];

	constructor(
		private userRestService: UserRestService,
		private router: Router,
		private privacyService: ProtectedPrivacyService,
		private menuService: MenuService,
		private permissionService: PermissionService,
	) {

	}

	ngOnInit(): void {
		this.users$ = this.userRestService.listUsers$();
		this.subscription.add(this.users$.subscribe(data => this.buildUserList(data)));
		this.subscription.add(this.privacyService.toggleChange$().subscribe(status => this.privacyMode = status ));
		this.subscription.add(this.permissionService.hasGlobalPermission$('users:create').subscribe(hasUserCreatePermission => {
			this.hasUserCreatePermission = hasUserCreatePermission;
		}));
		this.menuService.title = 'person.user';
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	currentPageDataChange(event): void {

	}

	compareUserName(a: NzTableData, b: NzTableData): number {
		return a.data.username.localeCompare(b.data.username);
	}

	filterUserName(): void {
		if (this.userNameFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: UserData) => item.data.username?.includes(this.userNameFilterValue.toLowerCase())
		);
	}

	compareName(a: NzTableData, b: NzTableData): number {
		return a.data.name?.localeCompare(b.data.name);
	}

	filterName(): void {
		if (this.nameFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: UserData) => item.data.name?.includes(this.nameFilterValue.toLowerCase())
		);
	}

	compareEmail(a: NzTableData, b: NzTableData): number {
		return a.data.email.localeCompare(b.data.email);
	}

	filterEmail(): void {
		if (this.emailFilterValue === '') {
			this.listOfDisplayData = this.listOfData;
		}
		this.listOfDisplayData = this.listOfData.filter(
			(item: UserData) => item.data.email?.includes(this.emailFilterValue.toLowerCase())
		);
	}

	compareRoles(a: NzTableData, b: NzTableData): number {
		let firstValue = a.data.roles[0];
		if (!firstValue) {
			firstValue = '';
		}
		return firstValue.localeCompare(b.data.roles[0]);
	}

	filterRoles(): void {
		if (this.roles.some(r => r.checked)) {
			this.listOfDisplayData = this.listOfData.filter(
				(item: UserData) => this.roles.some(r => item.data.roles.indexOf(r.value) !== -1)
			);
		}
		else {
			this.listOfDisplayData = this.listOfData;
		}
	}

	private buildUserList(user: UserDto[]): void {
		const list: UserData[] = [];
		user.forEach(u => {
			const userData = new UserData();
			userData.data = u;
			userData.url = userPages.stammDaten.base(u.username);
			list.push(userData);
			u.roles.forEach(role => {
				if (!this.roles || this.roles.some(r => u.roles.indexOf(r.value) === -1)) {
					if (!this.roles) {
						this.roles = [{label: role, value: role, checked: false}];
					}
					else {
						this.roles.push({label: role, value: role, checked: false});
					}
				}
			});
		});

		this.listOfData = list;
		this.listOfDisplayData = this.listOfData;
		this.loading = false;
	}

	showUserEdit(user: UserData): void {
		this.router
			.navigate([userPages.edit.base(user.data.username)])
			.catch(console.error);
	}

	showUserCreate(): void {
		this.router
			.navigate([userPages.create.base()])
			.catch(console.error);
	}
}
